import {Component, Input, OnInit} from '@angular/core';
import {
  AcVariantsCoveragesComparisonConfig,
  AcVariantsCoveragesCoverageConfigModel
} from '../ac-variants-coverages-comparison.config';
import {BeesafeAcCoverageVariant} from '../ac-variants.coverage';
import {OfferModification} from '../../../../../core/models/offer/offer-modification.model';
import {OfferModificationCode} from '../../../../../core/consts/offer-modification-code.enum';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {
  OfferModificationsConfigService
} from '../../../../../core/services/impl/offer-modifications/offer-modifications-config.service';
import {
  OfferModificationsService
} from '../../../../../core/services/impl/offer-modifications/offer-modifications.service';

@Component({
  selector: 'app-ac-variants-coverages-table',
  templateUrl: './ac-variants-coverages-table.component.html'
})
export class AcVariantsCoveragesTableComponent implements OnInit {

  @Input() visibleModifications: OfferModification[];
  public acVariantsConfig: AcVariantsCoveragesComparisonConfig;
  shortComparisonConfig: AcVariantsCoveragesCoverageConfigModel[];

  readonly variantsOrder: BeesafeAcCoverageVariant[] = [
      BeesafeAcCoverageVariant.NONE,
      BeesafeAcCoverageVariant.MINI,
      BeesafeAcCoverageVariant.WORKSHOP,
      BeesafeAcCoverageVariant.ASO,
  ];

  constructor(private configService: OfferModificationsConfigService,
              private offerModificationsService: OfferModificationsService) {
    this.acVariantsConfig = new AcVariantsCoveragesComparisonConfig(this.configService.insuranceCompanyCode, this.offerModificationsService);
    this.shortComparisonConfig = this.acVariantsConfig.getShortComparisonConfig();
  }

  ngOnInit() {
  }

  hasVariant(variant: BeesafeAcCoverageVariant): boolean {
    if (variant === BeesafeAcCoverageVariant.NONE) {
      return true;
    }
    return isNotNullOrUndefined(this.visibleModifications.find(mod => mod.code === OfferModificationCode.AC).options.find(option => option.value === variant));
  }

  getCoverageLabel(name: string): string {
    return `AC_VARIANTS_COMPARISON.coveragesLabels.${name}`;
  }

  getVariantValue(variant: BeesafeAcCoverageVariant, config: AcVariantsCoveragesCoverageConfigModel): string | boolean {
    const variantItem = config.values.find(item => item.coverage === variant);
    return variantItem ? variantItem.value : null;
  }
}
